import React, { useState, useEffect, useRef } from "react"
import CustomLink from "../Link"

const Dropdown = props => {
  const [isOpen, setIsOpen] = useState(false)
  const ref = useRef(null)
  const urlMatch = new RegExp("https?://|//")

  const handleClickOutside = event => {
    if (ref.current && !ref.current.contains(event.target)) {
      setIsOpen(false)
    }
  }

  const checkEnterKeypress = event => {
    const ENTER_KEY = 13
    if (event.keyCode === ENTER_KEY) {
      setIsOpen(!isOpen)
    }
  }

  useEffect(() => {
    document.addEventListener("mouseover", handleClickOutside, true)
    return () => {
      document.removeEventListener("mouseleave", handleClickOutside, true)
    }
  })

  return (
    <li
      className="navigation__label"
      ref={ref}
      onClick={() => setIsOpen(!isOpen)}
    >
      <div
        className="navigation__link navigation__dropdown"
        onKeyDown={checkEnterKeypress}
        role="button"
        tabIndex="0"
        aria-expanded={isOpen}
      >
        {props.menuItem.url.title}
        <svg
          style={isOpen ? { transform: "rotateX(180deg)" } : {}}
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          className="dropdown-icon"
        >
          <path d="M7 10l5 5 5-5z" />
          <path d="M0 0h24v24H0z" fill="none" />
        </svg>
        <ul style={{ display: `${isOpen ? "block" : "none"}` }}>
          {props.menuItem.submenu.map(childMenuItem => (
            <li key={childMenuItem.url.title}>
              <CustomLink url={childMenuItem.url.href} activeClassName="active">
                {childMenuItem.url.title}
                {childMenuItem.url.href.match(urlMatch) && (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    className="link-out-icon"
                  >
                    <path fill="none" d="M0 0h20v20H0V0z" />
                    <path d="M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z" />
                  </svg>
                )}
              </CustomLink>
            </li>
          ))}
        </ul>
      </div>
    </li>
  )
}

export default Dropdown
